"use client";

import { Compass, Home } from "lucide-react";
import { SiteHeader } from "@/components/site-chrome";
import { usePrefs } from "@/components/prefs-provider";
import { ButtonLink } from "@/components/ui/button";

export default function NotFound() {
  const { t } = usePrefs();
  return (
    <div className="min-h-screen bg-bg">
      <SiteHeader solid minimal />
      <main id="main-content" className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-4 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-soft text-brand-ink">
          <Compass className="h-8 w-8" aria-hidden />
        </span>
        <p className="tabular mt-6 text-sm font-bold text-ink-3">404</p>
        <h1 className="mt-1 font-display text-3xl font-bold tracking-tight text-ink">{t.errors.notFoundTitle}</h1>
        <p className="mt-3 leading-relaxed text-ink-2">{t.errors.notFoundBody}</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <ButtonLink href="/" icon={<Home className="h-4 w-4" aria-hidden />}>
            {t.errors.goHome}
          </ButtonLink>
          <ButtonLink href="/dashboard" variant="outline">
            {t.errors.goDashboard}
          </ButtonLink>
        </div>
      </main>
    </div>
  );
}
